import React, { useEffect, useLayoutEffect } from "react";
import MainContainer from "../../components/container/MainContainer";
import PageTitle from "../../components/titles/PageTitle";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../../components/loading/Loading";
import { getEmailedDonors, unsetDonors } from "../../features/donorsSlice";
import TextContainer from "../../components/text/TextContainer";
import {
  donorProposalEmailCompleted,
  getOnlyProject,
  getProject,
  unsetSelectedProject,
} from "../../features/projectsSlice";
import { ChevronLast, CircleCheck, Newspaper } from "lucide-react";
import { useNotification } from "../../components/notification/NotificationContainer";
import { openModal } from "../../features/modalSLice";
import ContactDonorCompleted from "./ContactDonorCompleted";
import Modal from "../../components/modal/Modal";
import useCustomBackButton from "./../../hooks/useCustomBackButton";
import { useState } from "react";
import { useCallback } from "react";
import loadStatus from "../../util/loadStatus";
import NetworkError from "../error/NetworkError";

const Reformulation = () => {
  const [error, setError] = useState(null);
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const addNotification = useNotification();
  const modalContent = useSelector((state) => state.modal.content);
  const project = useSelector((state) => state.projects.selected);
  const projectLoad = useSelector(
    (state) => state.projects.load.getOnlyProject
  );
  const donors = useSelector((state) => state.donors.data);
  const donorsLoad = useSelector((state) => state.donors.load.getEmailedDonors);

  const onHandleCompletedModal = () => {
    dispatch(openModal(<ContactDonorCompleted id={id} />));
  };

  const getAllData = useCallback(async () => {
    const allData = await Promise.all[
      (dispatch(getOnlyProject(id)),
      dispatch(getEmailedDonors({ id, data: { required: false } })))
    ];
  }, []);

  useLayoutEffect(() => {
    getAllData();

    return () => {
      dispatch(unsetSelectedProject());
      dispatch(unsetDonors());
    };
  }, []);

  useEffect(() => {}, [project, donors]);

  useLayoutEffect(() => {
    if (
      (project.id && project?.stage?.step_number < 12) ||
      (project.id && project?.stage?.step_number > 12)
    ) {
      return navigate("/projects/reformulations", { replace: true });
    }
  }, [project, navigate]);

  if (projectLoad === loadStatus.loading || donorsLoad === loadStatus.loading) {
    return <Loading />;
  }

  if (projectLoad === loadStatus.error || donorsLoad === loadStatus.error) {
    return <NetworkError to={location.pathname} />;
  }

  return (
    <MainContainer className="">
      {project.id ? (
        <>
          <Modal>{modalContent}</Modal>
          <PageTitle title="Mail To Donors" />
          <div className="sm:flex justify-between items-center p-5 border border-bkg2 bg-bkg rounded-md mb-5">
            <div className="mb-5 sm:mb-0">
              <TextContainer label="Title" content={project.name} />
              <TextContainer
                label="Location"
                content={project.project_location}
              />
              <TextContainer label="Community" content={project.community} />
            </div>
            <button
              onClick={onHandleCompletedModal}
              className="add-rss-btn text-center"
            >
              Done Sending
              <ChevronLast size={18} />
            </button>
          </div>
          <main className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-3">
            {donors.map((item, index) => (
              <div
                key={index}
                className="p-5 rounded-md bg-content shadow flex flex-col"
              >
                <Link
                  className="text-lg text-primary/80 font-bold hover:text-primary flex  items-center justify-between"
                  to={"/reformulations/donors/" + item.id + "/" + project.id}
                >
                  {item.name} <Newspaper size={20} />
                </Link>
                <div className="p-3 bg-bkg border border-bkg2 rounded-md my-3">
                  <TextContainer label="Email" content={item.email} />
                  <TextContainer label="Phone" content={item.phone} />
                  <TextContainer label="Adress" content={item.address1} />
                  <TextContainer label="Country" content={item.country} />
                </div>
                <div className="p-3">
                  {item &&
                    item.sentMails &&
                    item.sentMails.some((item) => item.type === "main") && (
                      <CircleCheck className="text-green-500" />
                    )}
                </div>
              </div>
            ))}
          </main>
        </>
      ) : (
        <Loading />
      )}
    </MainContainer>
  );
};

export default Reformulation;
